import { CustomMessage } from "../components";
import localStorageKey from "../enumerations/localStorageKey";

declare global {
  interface Window {
    dataLayer: any[];
  }
}

export const getLang = (): string | undefined => {
  const localLang = window.localStorage.getItem(localStorageKey.DEFAULT_LANG);
  switch (localLang) {
    case "jp":
      return "ja";
    default:
      return localLang || undefined;
  }
};

export const cleanedParams = (params: any): any => {
  return Object.keys(params).reduce((acc: any, key) => {
    const typedKey = key;
    if (params[typedKey] !== null && params[typedKey] !== undefined) {
      acc[typedKey] = params[typedKey];
    }
    return acc;
  }, {});
};

export const scrollToTop = (id: string) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollTo({ top: 0, behavior: "smooth" });
  }
};

export const objectToQuerystring = (obj: Object) =>
  Object.entries(obj)
    .filter(([, value]) => value !== null && value !== undefined)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join("&");

export const copyText = (text: string, successMessageContent: string) => {
  if (!text) return;
  // navigator.clipboard.writeText(text);
  const selectGroup = document.getElementById("copy-group");
  let tempArea = document.createElement("textarea");
  selectGroup?.appendChild(tempArea);
  tempArea.innerText = text;
  tempArea.select();
  document.execCommand("Copy");
  selectGroup?.removeChild(tempArea);

  CustomMessage({ alertMessage: successMessageContent, alertType: "success" });
};

export const handleClickCS = () => {
  window.open(process.env.REACT_APP_CUSTOMER_SERVICE_URL, "_blank");
};

export const envType = {
  NUMBER: "number",
  BOOLEAN: "boolean",
  ARRAY: "array",
  STRING: "string",
};

export const envChangeType = (target: string, type = envType.STRING) => {
  switch (type) {
    case envType.NUMBER:
    case envType.BOOLEAN:
      return JSON.parse(process.env[target] || "");
    case envType.ARRAY:
      return process.env[target]?.split(",");
    default:
      return process.env[target];
  }
};

export const pushGtag = (props: any = {}) => {
  if (
    envChangeType("REACT_APP_GCODE") !== "" &&
    envChangeType("REACT_APP_GCODE") !== null &&
    envChangeType("REACT_APP_GCODE") !== undefined
  ) {
    window.dataLayer.push({
      ...props,
    });
  }
};
